// import { createRouter, createWebHashHistory } from "vue-router";
import { createRouter, createWebHashHistory } from "vue-router";
import { useBasic } from "@/store/basic";

// import { createRouter, createWebHistory  } from "vue-router";
import { adminNavs, adminRoute } from "./admin";
import { helpNavs, helpRoutes } from "./help";
import { publicNavs, publicRoute } from "./public";
import { superNavs, superRoutes } from "./super";
import { WeixinEnum } from "@/components/Login/hooks/useTabs";

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: "/",
      redirect: publicRoute[0].path,
    },
    ...publicRoute,
    ...adminRoute,
    ...superRoutes,
    ...helpRoutes,
  ],
});

router.beforeEach((to, _form, next) => {
  const basic = useBasic();
  if (to.query.auth) {
    basic.loginToggle.toggle = true;
    basic.loginToggle.type =
      to.query.auth === "login"
        ? WeixinEnum.WeixinLogin
        : WeixinEnum.WeixinRegister;
    return next({
      path: to.path,
    });
  }
  document.title =
    to.meta.format && to.meta.name
      ? `${to.meta.name}二维码生成器_${to.meta.name}二维码在线制作_码舟二维码`
      : to.meta.name || "";
  next();
});

const navs = [...publicNavs, ...helpNavs];

export default router;
export { adminNavs, navs, superNavs };
